import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import colors from "common/theme/foundations/colors";

const InfoModal = (props) => {
  const { isOpen, onClose, message, handleLogout } =
    props;


  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <Modal onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Quick Info</ModalHeader>
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={props.onClose}
            icon={<CloseIcon />}
          />

          <ModalBody>{message}</ModalBody>
          <ModalFooter>
            <Button
              className="theme-btn2"
              variant="outline"
              size="sm"
              onClick={handleClose}
            >
              Ok
            </Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default InfoModal;
